////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { map, isNull, isEmpty, isEqual } from 'lodash'
import { useRouteMatch } from 'react-router'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import { telecollectManagerActionCreators } from '../../../store/actions'
import theme from '../../../theme/theme'

//////STYLED//////
const Wrapper = styled.div`
	display: grid;
	grid-template-column: 1fr;
`
const Title = styled.div`
	font-weight: ${theme.weight.bold};
	font-size: ${theme.font.fxl};
	margin: 10px 0;
`
const TicketWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`
const DataWrapper = styled.div`
	width: max-content;
	height: max-content;
	border: 1px solid ${(props) => props.theme.colors.tabText};
	padding: 1%;
	display: grid;
	grid-template-columns: auto auto;
	& > div:nth-child(2n -1) {
		text-align: left;
	}
	& > div {
		padding: 0px 10px;
		/* border-bottom: 1px solid ${(props) => props.theme.colors.black}; */
		min-height: 23px;
	}
	& > div:nth-last-child(1) {
		border-bottom: none;
	}
	/* & > div:nth-last-child(2) {
		border-bottom: none; */
	}
`
const ValueWrapper = styled.div`
	color: ${(props) => props.theme.colors.tabText};
	text-align: left;
	grid-column: 1;
`
//////STYLED//////

const TelecollectTicket = (props) => {
	const { user, translations, telecollectTicket } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
			telecollectTicket: state.telecollectManager.telecollectTicket,
		}),
		shallowEqual
	)

	const match = useRouteMatch()

	const actionsTelecollectManager = bindActionCreators(telecollectManagerActionCreators, useDispatch())

	const [formattedData, setFormattedData] = useState([])

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	// For testing
	useEffect(() => {
		!isEmpty(translations) && actionsTelecollectManager.getTelecollectTicket(match.params.id)
	}, [user, translations])

	// Ticket is sent at string format, we need to parse it
	useEffect(() => {
		if (!isEqual(telecollectTicket, {})) {
			if (!isNull(telecollectTicket.ticket)) {
				let wantedRow = telecollectTicket.ticket.split('\n')
				setFormattedData(wantedRow)
			}
		}
	}, [telecollectTicket, translations])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		!isEmpty(formattedData) && (
			<Wrapper>
				<TicketWrapper>
					<Title>{translations['page__tpeTicket__ticketType_telecollect']}</Title>
					<DataWrapper>{!isEmpty(formattedData) && map(formattedData, (elem, id) => <ValueWrapper>{elem}</ValueWrapper>)}</DataWrapper>
				</TicketWrapper>
			</Wrapper>
		)
	)
}

TelecollectTicket.propTypes = {}

TelecollectTicket.defaultPropTypes = {}

export default TelecollectTicket
